const { DeviceType, SurveyType } = require('../services/prisma/types');

const ACTIVE = 'ACTIVE';
const INACTIVE = 'INACTIVE';
const SCHEDULED = 'SCHEDULED';
const EXPIRED = 'EXPIRED';
const MISSING_POLICY = 'MISSING_POLICY';
const MISSING_LICENSE = 'MISSING_LICENSE';
const LICENSE_LIMIT = 'LICENSE_LIMIT';

const DISTRIBUTION_STATUS = {
  ACTIVE,
  LICENSE_LIMIT,
  MISSING_LICENSE,
  MISSING_POLICY,
  SCHEDULED,
  EXPIRED,
  INACTIVE,
};

const MINUTE = 60;
const DAY = 24 * 60 * 60;

const DEFAULT_THEME_VALUES = {
  theme: 'default',
};

const DEFAULT_DESIGN_VALUES = {
  containerType: null,
  popupWidth: 520,
  popupHeight: 480,
  quizMode: false,
  useToggleButtons: false,
  showProgress: false,
  logoSource: 'CUSTOMER',
  logoHeight: 24,
};

const DEFAULT_BEHAVIOR_VALUES = {
  portion: 100,
  delay: `${2 * MINUTE}`,
  frequency: `${90 * DAY}`,
  declineFrequency: 30 * DAY,
  container: 'popupWindow',
  trigger: null,
  triggerPosition: null,
  triggerStyle: null,
  buttonLabel: null,
  buttonIcon: null,
  elementSelector: null,
};

const DEFAULT_GENERAL_SURVEY_DESKTOP_VALUES = {
  ...DEFAULT_THEME_VALUES,
  ...DEFAULT_DESIGN_VALUES,
  ...DEFAULT_BEHAVIOR_VALUES,
};

const DEFAULT_GENERAL_SURVEY_MOBILE_VALUES = {
  ...DEFAULT_GENERAL_SURVEY_DESKTOP_VALUES,
  container: 'popupLayer',
  containerType: 'modal',
};

const DEFAULT_GENERAL_SURVEY_TABLET_VALUES = {
  ...DEFAULT_GENERAL_SURVEY_MOBILE_VALUES,
};

const DEFAULT_FEEDBACK_VALUES = {
  ...DEFAULT_THEME_VALUES,
  ...DEFAULT_DESIGN_VALUES,
  portion: 100,
  trigger: 'button',
  triggerPosition: 'centerRight',
  triggerStyle: 'tab',
  container: 'popupLayer',
  containerType: 'speechBubble',
  buttonLabel: 'Feedback',
  buttonIcon: null,
};

const DEFAULT_DEVICE_VALUES = {
  [SurveyType.General]: {
    [DeviceType.Desktop]: DEFAULT_GENERAL_SURVEY_DESKTOP_VALUES,
    [DeviceType.Mobile]: DEFAULT_GENERAL_SURVEY_MOBILE_VALUES,
    [DeviceType.Tablet]: DEFAULT_GENERAL_SURVEY_TABLET_VALUES,
  },
  [SurveyType.Feedback]: {
    [DeviceType.Desktop]: DEFAULT_FEEDBACK_VALUES,
    [DeviceType.Mobile]: DEFAULT_FEEDBACK_VALUES,
    [DeviceType.Tablet]: DEFAULT_FEEDBACK_VALUES,
  },
  [SurveyType.Targeted]: {
    [DeviceType.Desktop]: DEFAULT_GENERAL_SURVEY_DESKTOP_VALUES,
    [DeviceType.Mobile]: DEFAULT_GENERAL_SURVEY_MOBILE_VALUES,
    [DeviceType.Tablet]: DEFAULT_GENERAL_SURVEY_TABLET_VALUES,
  },
  [SurveyType.Cx]: {
    [DeviceType.Desktop]: DEFAULT_GENERAL_SURVEY_DESKTOP_VALUES,
    [DeviceType.Mobile]: DEFAULT_GENERAL_SURVEY_MOBILE_VALUES,
    [DeviceType.Tablet]: DEFAULT_GENERAL_SURVEY_TABLET_VALUES,
  },
};

const THEME_PROPS = Object.keys(DEFAULT_THEME_VALUES);
const DESIGN_PROPS = Object.keys(DEFAULT_DESIGN_VALUES);
const BEHAVIOR_PROPS = Object.keys(DEFAULT_BEHAVIOR_VALUES);

module.exports = {
  DISTRIBUTION_STATUS,
  DEFAULT_DEVICE_VALUES,
  THEME_PROPS,
  BEHAVIOR_PROPS,
  DESIGN_PROPS,
};
